import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.hint))]),
      _vm._v(" "),
      _vm._l(_vm.vModel, function (textField, i) {
        return _c(
          "AtTextField",
          _vm._b(
            {
              key: i,
              attrs: { label: "" },
              model: {
                value: _vm.vModel[i],
                callback: function ($$v) {
                  _vm.$set(_vm.vModel, i, $$v)
                },
                expression: "vModel[i]",
              },
            },
            "AtTextField",
            _vm.$attrs,
            false
          )
        )
      }),
      _vm._v(" "),
      !_vm.$attrs.readonly
        ? _c(
            VBtn,
            {
              staticClass: "mb-3",
              attrs: {
                text: "",
                color: "primary",
                disabled: _vm.vModel ? _vm.vModel.includes("") : true,
              },
              on: {
                click: function ($event) {
                  return _vm.vModel.push("")
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("components.AtTextFieldGroup.add_more")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }